/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 29/04/2025 17:42
 *
 */

import { Component, input, signal } from '@angular/core';
import { TouchAction } from '../touch-action';
import {
  ActionEvent,
  CommonUtils,
  DropdownAction,
  StandardAction,
} from '@infodata-group/inf-commons';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'infl-touch-dropdown-action',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './touch-dropdown-action.component.html',
  styleUrls: ['./touch-dropdown-action.component.scss', '../touch-action.scss'],
})
export class TouchDropdownActionComponent extends TouchAction {
  public override action = input.required<DropdownAction>();

  protected onClickSubAction(action: StandardAction) {
    this.actionClick.emit(new ActionEvent('click', action));
  }

  protected black = signal<string>(CommonUtils.color('black'));
}
